import { IconButton } from '@material-ui/core';
import React, { FC } from 'react';
import { useCouriersActions } from '../../context/couriers';
import { IOrder, useOrdersActions } from '../../context/orders';
import OrderListItem from '../OrderListItem';
import useStyles from './styles';
import JetCrossDefault from '@assets/JETCross-content-default.svg';
import { useAccordionActions } from '@src/shared/context/accordion';
import { useInsideDrawerActions } from '@src/shared/context/inside-drawer';

interface OrderDetailProps extends IOrder {
  isMobile?: boolean;
}

export const OrderDetail: FC<OrderDetailProps> = (props) => {
  const classes = useStyles();
  const { setSelectedCourierId } = useCouriersActions();
  const { setSelectedOrderId } = useOrdersActions();
  const { flushHoveredOrder } = useAccordionActions();
  const { setDrawerFlush } = useInsideDrawerActions();
  const flushSelections = () => {
    setSelectedCourierId(null);
    setSelectedOrderId(null);
    flushHoveredOrder()
    setDrawerFlush()
  };

  return (
    <>
      <div
        className={`${classes.orderDetailWrapper} ${
          props.isMobile ? 'mobile' : ''
        }`}
      >
        <div className={classes.orderTitle}>
          <h2>Order</h2>
          <IconButton
            onClick={flushSelections}
            classes={{ root: classes.closeButton }}
            aria-label="close"
          >
            <img
              src={JetCrossDefault}
              className={classes.closeButtonIcon}
              alt="Close"
            />
          </IconButton>
        </div>
        <ul className={classes.list}>
          <OrderListItem {...props} />
        </ul>
      </div>
    </>
  );
};

export default OrderDetail;
